import { gql } from 'apollo-angular';

export const AUTHENTICATE_WITH_PASSWORD = gql`
  mutation AuthenticateWithPassword(
    $aptitudeOrgId: Long!
    $username: String!
    $password: String!
    $acceptedTermsOfUse: Boolean
  ) {
    authenticateWithPassword(
      input: {
        aptitudeOrgId: $aptitudeOrgId
        username: $username
        password: $password
        acceptedTermsOfUse: $acceptedTermsOfUse
      }
    ) {
      username
      token
      mustAcceptTermsOfUse
    }
  }
`;

export type AuthenticateWithPasswordRequest = {
  aptitudeOrgId: number;
  username: string;
  password: string;
  acceptedTermsOfUse?: boolean;
};
